import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let AmBizNavMain = class AmBizNavMain extends Vue {
  constructor() {
    super(...arguments);
    this.loaded = false;
  }
  mounted() {
    setTimeout(() => {
      this.loaded = true;
    }, 2000);
  }
};
AmBizNavMain.componentName = 'AmBizNavMain';
__decorate([Prop({
  default: 2
})], AmBizNavMain.prototype, "type", void 0);
__decorate([Prop({
  default: 1
})], AmBizNavMain.prototype, "displayType", void 0);
__decorate([Prop({
  default: 'ote_arrange_mgmt'
})], AmBizNavMain.prototype, "functionCode", void 0);
__decorate([Prop({
  default: 'o2o'
})], AmBizNavMain.prototype, "appName", void 0);
__decorate([Prop({
  default: true
})], AmBizNavMain.prototype, "isShowLeftNav", void 0);
__decorate([Prop({
  default: true
})], AmBizNavMain.prototype, "isShowTopNav", void 0);
__decorate([Prop({
  default: true
})], AmBizNavMain.prototype, "isShowFooter", void 0);
__decorate([Prop({
  default: false
})], AmBizNavMain.prototype, "isShowHelpCenter", void 0);
__decorate([Prop({
  default: false
})], AmBizNavMain.prototype, "isSetTitle", void 0);
__decorate([Prop({
  default: true
})], AmBizNavMain.prototype, "isCheckPermission", void 0);
__decorate([Prop({
  default: {
    datas: [{
      id: '1',
      parentId: '',
      code: 'test1',
      functionCode: 'test1',
      name: '一级导航1',
      enName: '一级导航1',
      haName: 'nav top',
      showed: true
    }, {
      id: '2',
      parentId: '',
      code: 'test2',
      functionCode: 'test2',
      pageUrl: '',
      name: '一级导航2',
      enName: '一级导航2',
      haName: 'nav top',
      showed: true
    }, {
      id: '11',
      parentId: '1',
      code: 'test11',
      functionCode: 'test1',
      name: '二级导航1',
      enName: '二级导航1',
      pageUrl: '',
      haName: 'nav top',
      navIcon: 'yxt-icon-office-building',
      showed: true
    }, {
      id: '111',
      parentId: '11',
      code: 'test112',
      functionCode: 'test1',
      name: '三级导航1',
      enName: '三级导航1',
      pageUrl: '',
      haName: 'nav top',
      openMode: '_self',
      showed: true
    }, {
      id: '112',
      parentId: '11',
      code: 'ote_arrange_mgmt',
      functionCode: 'test1',
      name: '三级导航2',
      enName: '三级导航2',
      haName: 'nav top',
      pageUrl: '',
      openMode: '_self',
      showed: true
    }, {
      id: '113',
      parentId: '11',
      code: 'test113',
      functionCode: 'test1',
      name: '三级导航3',
      enName: '三级导航3',
      haName: 'nav top',
      pageUrl: '',
      openMode: '_blank',
      showed: true
    }, {
      id: '12',
      parentId: '1',
      code: 'test12',
      functionCode: 'test1',
      name: '二级导航2',
      enName: '二级导航2',
      haName: 'nav top',
      navIcon: 'yxt-icon-office-building',
      showed: true
    }, {
      id: '121',
      parentId: '12',
      code: 'test121',
      functionCode: 'test1',
      name: '三级导航1',
      enName: '三级导航1',
      haName: 'nav top',
      showed: true
    }, {
      id: '122',
      parentId: '12',
      code: 'test122',
      functionCode: 'test1',
      name: '三级导航2',
      enName: '三级导航2',
      haName: 'nav top',
      showed: true
    }]
  }
})], AmBizNavMain.prototype, "navDatas", void 0);
AmBizNavMain = __decorate([Component({
  name: 'AmBizNavMain'
})], AmBizNavMain);
export default AmBizNavMain;